/**
 * Persists a bookmarkable resume pointer for public popup-store setup.
 * The store itself lives in Firestore; this only helps the creator find
 * their setup URL again on the same browser after leaving mid-flow.
 */

const STORAGE_KEY = "publicStoreSetupResume";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function savePublicStoreSetupResume({
  shopId,
  resumePath,
  domain = null,
}) {
  if (typeof window === "undefined") return;
  const id = String(shopId || "").trim();
  const path = String(resumePath || "").trim();
  if (!id || !path) return;

  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        shopId: id,
        resumePath: path,
        domain: domain || null,
        hostname: window.location.hostname,
        savedAt: Date.now(),
      })
    );
  } catch (_err) {
    // Ignore quota / private-mode failures — URL resume still works.
  }
}

export function readPublicStoreSetupResume() {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (!data?.shopId || !data?.resumePath) return null;
    if (data.hostname && data.hostname !== window.location.hostname) {
      return null;
    }
    if (data.savedAt && Date.now() - data.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data;
  } catch (_err) {
    return null;
  }
}

export function clearPublicStoreSetupResume() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (_err) {
    // no-op
  }
}
